/* eslint-disable brace-style */
export const forEach = (arr, fn) => {
    if (!arr.length || !fn) return
    let i = -1
    let len = arr.length
    while (++i < len) {
        let item = arr[i]
        fn(item, i, arr)
    }
}

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
 */
export const getIntersection = (arr1, arr2) => {
    let len = Math.min(arr1.length, arr2.length)
    let i = -1
    let res = []
    while (++i < len) {
        const item = arr2[i]
        if (arr1.indexOf(item) > -1) res.push(item)
    }
    return res
}

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的并集, 两个数组的元素为数值或字符串
 */
export const getUnion = (arr1, arr2) => {
    return Array.from(new Set([...arr1, ...arr2]))
}

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetarr, arr) => {
    return targetarr.some(_ => arr.indexOf(_) > -1)
}

/**
 * @param {String|Number} value 要验证的字符串或数值
 * @param {*} validList 用来验证的列表
 */
export function oneOf(value, validList) {
    for (let i = 0; i < validList.length; i++) {
        if (value === validList[i]) {
            return true
        }
    }
    return false
}

/**
 * @param {Number} timeStamp 判断时间戳格式是否是毫秒
 * @returns {Boolean}
 */
const isMillisecond = timeStamp => {
    const timeStr = String(timeStamp)
    return timeStr.length > 10
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} currentTime 当前时间时间戳
 * @returns {Boolean} 传入的时间戳是否早于当前时间戳
 */
const isEarly = (timeStamp, currentTime) => {
    return timeStamp < currentTime
}

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = num => {
    return num < 10 ? '0' + num : num
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} startType 要返回的时间字符串的格式类型，传入'year'则返回年开头的完整时间
 */
const getDate = (timeStamp, startType) => {
    const d = new Date(timeStamp * 1000)
    const year = d.getFullYear()
    const month = getHandledValue(d.getMonth() + 1)
    const date = getHandledValue(d.getDate())
    const hours = getHandledValue(d.getHours())
    const minutes = getHandledValue(d.getMinutes())
    const second = getHandledValue(d.getSeconds())
    let resStr = ''
    if (startType === 'year') {
        resStr = `${year}-${month}-${date} ${hours}:${minutes}:${second}`
    } else resStr = month + '-' + date + ' ' + hours + ':' + minutes
    return resStr
}

/**
 * @param {String|Number} timeStamp 时间戳
 * @returns {String} 相对时间字符串
 */
export const getRelativeTime = timeStamp => {
    // 判断当前传入的时间戳是秒格式还是毫秒
    const IS_MILLISECOND = isMillisecond(timeStamp)
    // 如果是毫秒格式则转为秒格式
    if (IS_MILLISECOND) Math.floor((timeStamp /= 1000))
    // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
    timeStamp = Number(timeStamp)
    // 获取当前时间时间戳
    const currentTime = Math.floor(Date.parse(new Date()) / 1000)
    // 判断传入时间戳是否早于当前时间戳
    const IS_EARLY = isEarly(timeStamp, currentTime)
    // 获取两个时间戳差值
    let diff = currentTime - timeStamp
    // 如果IS_EARLY为false则差值取反
    if (!IS_EARLY) diff = -diff
    let resStr = ''
    const dirStr = IS_EARLY ? '前' : '后'
    // 少于等于59秒
    if (diff <= 59) resStr = diff + '秒' + dirStr
    // 多于59秒，少于等于59分钟59秒
    else if (diff > 59 && diff <= 3599) {
        resStr = Math.floor(diff / 60) + '分钟' + dirStr
    }
    // 多于59分钟59秒，少于等于23小时59分钟59秒
    else if (diff > 3599 && diff <= 86399) {
        resStr = Math.floor(diff / 3600) + '小时' + dirStr
    }
    // 多于23小时59分钟59秒，少于等于29天59分钟59秒
    else if (diff > 86399 && diff <= 2623859) {
        resStr = Math.floor(diff / 86400) + '天' + dirStr
    }
    // 多于29天59分钟59秒，少于364天23小时59分钟59秒，且传入的时间戳早于当前
    else if (diff > 2623859 && diff <= 31567859 && IS_EARLY) {
        resStr = getDate(timeStamp)
    } else resStr = getDate(timeStamp, 'year')
    return resStr
}

/**
 * @returns {String} 当前浏览器名称
 */
export const getExplorer = () => {
    const ua = window.navigator.userAgent
    const isExplorer = exp => {
        return ua.indexOf(exp) > -1
    }
    if (isExplorer('MSIE')) return 'IE'
    else if (isExplorer('Firefox')) return 'Firefox'
    else if (isExplorer('Chrome')) return 'Chrome'
    else if (isExplorer('Opera')) return 'Opera'
    else if (isExplorer('Safari')) return 'Safari'
}

/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function() {
    if (document.addEventListener) {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.addEventListener(event, handler, false)
            }
        }
    } else {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.attachEvent('on' + event, handler)
            }
        }
    }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function() {
    if (document.removeEventListener) {
        return function(element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false)
            }
        }
    } else {
        return function(element, event, handler) {
            if (element && event) {
                element.detachEvent('on' + event, handler)
            }
        }
    }
})()

/**
 * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
 * 如果没有传入key这个参数，则判断obj对象是否有键值对
 */
export const hasKey = (obj, key) => {
    if (key) return key in obj
    else {
        let keysArr = Object.keys(obj)
        return keysArr.length
    }
}

/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
export const objEqual = (obj1, obj2) => {
    const keysArr1 = Object.keys(obj1)
    const keysArr2 = Object.keys(obj2)
    if (keysArr1.length !== keysArr2.length) return false
    else if (keysArr1.length === 0 && keysArr2.length === 0) return true
    /* eslint-disable-next-line */ else {
    return !keysArr1.some(key => obj1[key] != obj2[key])
    }
}

export const openWindow = (url, title, w, h) => {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top
    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height
    const left = ((width / 2) - (w / 2)) + dualScreenLeft
    const top = ((height / 2) - (h / 2)) + dualScreenTop
    const newWindow = window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left)
    if (window.focus) {
        newWindow.focus()
    }
}

export const getWeekOfDay = (day) => {
    const weeks = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
    let week = new Date(Date.parse(day.replace(/-/g, '/'))).getDay()
    return weeks[week]
}

/**
* 根据传入开始、结束日期，拆分成多少晚，并返回成数组
* @param {str} 开始日期
* @param {end} 结束日期
*/
export const __dateRangeSplitDay = (str, end) => {
    const strDateArr = str.split('-')
    const endDateArr = end.split('-')
    const strYear = strDateArr[0]
    const strMonth = strDateArr[1]
    const strDate = strDateArr[2]
    const endYear = endDateArr[0]
    const endMonth = endDateArr[1]
    const endDate = endDateArr[2]
    let dateList = []
    let flag = true
    let yearStr = strYear
    for (let k = 0; k < (endYear - strYear + 1); k++) {
        if ((+endYear === +strYear) && (+strMonth === +endMonth)) {
            for (let k = 0; k < (endDate - strDate); k++) {
                const key = `${yearStr}-${strMonth}-${strDate - 0 + k < 10 ? `0${(strDate - 0 + k)}` : strDate - 0 + k}`
                dateList.push(key)
            }
        } else {
            // 获取当前月的最后一天，这里一般用于判断开始日期月末是哪一天
            const lastMonthRestDay = new Date(strYear, strMonth, 0).getDate()
            for (let i = 0; i < (lastMonthRestDay - strDate + 1); i++) {
                const key = `${strYear}-${strMonth}-${(lastMonthRestDay - i) < 10 ? `0${(lastMonthRestDay - i)}` : lastMonthRestDay - i}`
                dateList.unshift(key)
            }
            // 公共方法改造，要判断多个月份跨度
            let yearMonth = 0
            let qq = 0
            if (+endYear === +yearStr && flag) {
                qq = strMonth
                yearMonth = endMonth - strMonth - 1
            } else if (+endYear !== +yearStr && flag) {
                qq = strMonth
                yearMonth = 12 - strMonth
            } else if (+endYear !== +yearStr) {
                qq = 0
                yearMonth = 11
            } else {
                yearMonth = endMonth
            }
            for (let i = 0; i < yearMonth; i++) {
                qq++
                const endDates = new Date(yearStr, qq, 0).getDate()
                for (let j = 0; j < endDates; j++) {
                    const key = `${yearStr}-${qq < 10 ? `0${qq}` : qq}-${j < 9 ? `0${j + 1}` : (j + 1)}`
                    dateList.push(key)
                }
            }
            if (+endYear === +yearStr) {
                for (let j = 0; j < (endDate - 1); j++) {
                    const key = `${yearStr}-${endMonth}-${j < 9 ? `0${(j + 1)}` : j + 1}`
                    dateList.push(key)
                }
            }
        }
        yearStr++
        flag = false
    }
    return dateList
}

/**
 * 第三微信、QQ、IN 账号登录名称显示
 */

export const __showSserAccount = (userAccount) => {
    const isQQLogin = /from_tencent$/.test(userAccount)
    const isWechatLogin = /from_wechat$/.test(userAccount)
    const isLinkedin = /from_linkedin$/.test(userAccount)
    if (isQQLogin || isWechatLogin || isLinkedin) {
        const userAccountAlias = document.cookie.split('; ').filter(item => /userAccountAlias=\s?/.test(item))
        if (!userAccountAlias.length) {
            return
        }
        return unescape(userAccountAlias[0].split('=')[1])
    }
    return userAccount
}

export const __browserVersions = () => {
    var u = navigator.userAgent
    return {
        trident: u.indexOf('Trident') > -1, // IE内核
        presto: u.indexOf('Presto') > -1, // opera内核
        webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*(Mobile|Phone|Tablet)+?/i), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
        iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, // 是否iPad
        webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) === ' qq' // 是否QQ
    };
}

/**
 * 将字符串转换为字节数
 * @param {String} str: 字符串
 * @returns {Number} length: 字节数
 */
export const utf8Strlen = str => {
    let length = 0
    for (let i = 0; i < str.length; i++) {
        let code = str.charCodeAt(i)
        if ((code >= 0x0001 && code <= 0x007e) || (code >= 0xff60 && code <= 0xff9f)) {
            length += 1
        } else {
            length += 2
        }
    }
    return length
}

/**
 * 类型检测
 * @returns {String} 数据类型的字符串
 */
export const typeCheck = data => {
    return Object.prototype.toString.call(data).slice(8, -1)
}

/**
 * 对比数据
 * @param {Object} newData 新数据对象
 * @param {Object} oldData 旧数据对象
 * @param {Array} excludeParams 排除对比的属性名数组
 * @returns {Boolean} 是否有发生变化
 */
export const objectComparison = (newData, oldData, excludeParams = []) => {
    let curType = typeCheck(newData)
    if (['Array', 'Object'].some(item => item === curType) && curType !== typeCheck(oldData)) {
        return true
    }
    // 先判断是否是数组
    if (curType === 'Array') {
        // 先判断长度, 长度一样才对比
        return !oldData || newData.length !== oldData.length || newData.some((item, i) => objectComparison(newData[i], oldData[i] || {}, excludeParams))
    } else if (curType === 'Object') {
        // 否则为对象
        return Object.keys(newData).forEach(key => {
            // 如果是排除项则不进行对比
            if (!excludeParams.forEach(it => it === key)) {
                let newValue = newData[key]
                let oldValue = oldData[key]
                let type = typeCheck(newValue)
                if (type === 'Array') {
                    return !oldValue || newValue.length !== oldValue.length || newValue.some((item, i) => objectComparison(newValue[i], oldValue[i] || {}, excludeParams))
                } else if (type === 'Object') {
                    return objectComparison(newValue, oldValue, excludeParams)
                } else {
                    // 新旧值不等则返回true (错误信息不进行对比)
                    // (新值对应的旧值可能是 空字符串或数字或null或undefined, 用!== 会非常麻烦, 所以使用!=进行隐式类型转换对比)
                    return key.indexOf('Error') === -1 && (newValue || '') != (oldValue || '')  // eslint-disable-line
                }
            }
        })
    } else {
        // (新值对应的旧值可能是 空字符串或数字或null或undefined, 用!== 会非常麻烦, 所以使用!=进行隐式类型转换对比)
        return (newData || '') != (oldData || '')  // eslint-disable-line
    }
}

/**
 * 转换为浮点数
 * @param {String/Number} value 原始值
 * @param {Number} bit 要保留整数位数
 * @returns {String} 转换后的浮点数字符串
 */
export const transformFloat = (value, bit = 7) => {
    value = `${value}` // 转为字符串
        .replace(/[^\d.]/g, '') // 只允许“数字”和“.”字符
        .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
        .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        .replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
    if (value.indexOf('.') < 0 && value !== '') { // 没小数点，
        value = parseFloat(value) + '' // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = value.slice(0, bit) // 保留指定位数
    } else if (value.indexOf('.') > -1 && value !== '') { // 有小数点，
        let arr = value.split('.') // 分割成数组
        let int = `${parseFloat(arr[0]) || 0}`.slice(0, bit) // 整数部分保留指定位数
        value = `${int}.${arr[1]}`
    }
    return value
}

/** 获取lookup对应值 */
export const __getLookupValue = (code, list = [], valueName = 'itemName') => {
    if (!code) return ''
    return (list.filter(item => item.itemCode === code)[0] || { [valueName]: code })[valueName];
}

/**
 * 获取对象数组中某个对象所在index
 * @param {Array} list 数字
 * @param {Function} fn 函数
 * @param {Number|String} defaultIndex 默认index
 * @returns {Number} index
 */
export const __getIndexOf = (list, fn, defaultIndex = -1) => {
    let index = defaultIndex
    list.forEach((item, i) => {
        if (fn(item)) {
            index = i
            return true
        }
    })
    return index
}

/**
 * 获取对象数组中某个对象所在index
 */
export const __some = (value, list) => {
    return list.some(item => item === value)
}

/** 获取地址栏url */
export const getWinOrigin = () => {
    return window.location.origin.replace(/(:\d+)/, '');
}

/** 获取地址栏后缀 */
export const getLocationOrgin = () => {
    let winOriginSplit = getWinOrigin().split('.')
    return `.${winOriginSplit && winOriginSplit[winOriginSplit.length - 1] || 'com'}`
}

/**
 * 替换请求url后缀
 * @param {String} url 需替换的url
 * @param {Boolean} allReplace 是否全部替换
 * @returns {String} 替换后的url
 */
export const __replaceDotCom = (url, allReplace) => {
    if (allReplace) {
        if (process.env.VUE_APP_BUILD_ENV === 'dev') {
            return url
        }
        return `${getWinOrigin()}/eventsgo/gateway/`
    }
    return url && url.replace('.com', getLocationOrgin())
}

export const getCountryName = (countryList, country) => {
    let countryName = ''
    countryList.some(el => {
        if (el.country_alpha_2_code === country) {
            countryName = el.countryName
            return true
        }
        return false
    })
    return countryName
}

export const getQueryVariable = (url) => { // 解析URL，提取GET参数
    let params = {}
    let queryString = url.split('?')[1]
    if (queryString) {
        let pairs = queryString.split('&')
        for (let i = 0; i < pairs.length; i++) {
            let pair = pairs[i].split('=')
            let key = decodeURIComponent(pair[0])
            let value = decodeURIComponent(pair[1])
            params[key] = value
        }
    }
    return params
}

// url拼接参数
export const setQueryParam = (url, data) => {
    if (!url) { return {} }
    let urlObject = new URL(url)
    urlObject.search = ''
    let newUrl = urlObject.href
    for (let k in data) {
        let value = data[k] || ''
        newUrl += `${newUrl.indexOf('?') > -1 ? '&' : '?'}${k}=${value}`
    }
    return newUrl
}
